import type { Profile } from '@/http/zamply/user/get-profile-schema'

/** Cached session must not outlive a login as a different user. */
export function resolveSessionUser(
  cachedUser: Profile | null | undefined,
  initialUser: Profile | null | undefined
): Profile | null {
  if (
    cachedUser &&
    initialUser &&
    cachedUser.reference !== initialUser.reference
  ) {
    return initialUser
  }

  return cachedUser ?? initialUser ?? null
}
